module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.ebeacdb3.woff2";